"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _Modal = require("./Modal.styled");
var _flexComponents = require("../atoms/flex-components");
var _Text = _interopRequireDefault(require("../atoms/Text"));
var _ButtonIconOnly = require("../atoms/button/ButtonIconOnly");
var _IconTooltip = _interopRequireDefault(require("../../forecast-v2/components/feedback/tooltip/IconTooltip"));
var _Button = _interopRequireWildcard(require("../../forecast-v2/components/controls/buttons/Button"));
var _components = require("../../forecast-v2/components");
var _jsxRuntime = require("react/jsx-runtime");
/**
 * A modal for creation
 *
 * @param closeModal A function that closes the modal
 * @param title The title for the modal header
 * @param tooltip The tooltip to shown in the modal header
 * @param creativeButtonText Text for the creative button
 * @param children The Modal content
 * @param onCreateHandler Function to be called on 'create' button click
 * @param disabled Modal in disabled state
 * @param size The size of the modal, ['s', 'm', 'l']
 * @param data-cy The Cypress data tag
 * @returns {JSX.Element} The Modal
 */
var TimeRegCreativeModal = function TimeRegCreativeModal(_ref) {
  var children = _ref.children,
    closeModal = _ref.closeModal,
    title = _ref.title,
    tooltip = _ref.tooltip,
    betaLink = _ref.betaLink,
    creativeButtonText = _ref.creativeButtonText,
    secondaryButtonText = _ref.secondaryButtonText,
    tertiaryButtonText = _ref.tertiaryButtonText,
    quarternaryButtonText = _ref.quarternaryButtonText,
    onCreateHandler = _ref.onCreateHandler,
    onSecondaryHandler = _ref.onSecondaryHandler,
    onTertiaryHandler = _ref.onTertiaryHandler,
    onQuarternaryHandler = _ref.onQuarternaryHandler,
    disabled = _ref.disabled,
    size = _ref.size,
    dataCy = _ref['data-cy'];
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Modal.ModalContainer, {
    onClick: closeModal,
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Modal.ModalBox, {
      onClick: function onClick(e) {
        return e.stopPropagation();
      },
      size: size,
      "data-cy": dataCy,
      replicateDesignSystem: true,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_flexComponents.FlexRow, {
        justifyContent: 'space-between',
        children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_flexComponents.FlexRow, {
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Text.default, {
            type: 'heading',
            variant: 'xl',
            children: title
          }), tooltip ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_IconTooltip.default, {
            icon: 'info',
            children: tooltip
          }) : null, betaLink]
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_ButtonIconOnly.ButtonIconOnly, {
          size: 'l',
          type: 'ghost',
          icon: 'close',
          onClick: closeModal
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Modal.ContentContainer, {
        children: children
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_flexComponents.FlexRow, {
        justifyContent: 'space-between',
        children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_flexComponents.FlexRow, {
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.default, {
            disabled: disabled,
            onClick: onCreateHandler,
            "data-cy": 'creative_button',
            "data-userpilot": 'time_reg_creative_button',
            children: creativeButtonText
          }), onSecondaryHandler || secondaryButtonText ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.default, {
            emphasis: _Button.EMPHASIS.MEDIUM,
            disabled: disabled,
            onClick: onSecondaryHandler,
            "data-cy": 'creative_sec_button',
            "data-userpilot": 'time_reg_creative_sec_button',
            children: secondaryButtonText
          }) : null]
        }), onQuarternaryHandler || onTertiaryHandler ? /*#__PURE__*/(0, _jsxRuntime.jsxs)(_flexComponents.FlexRow, {
          justifyContent: 'flex-end',
          gap: 'm',
          children: [onQuarternaryHandler ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.Link, {
            size: '2',
            onClick: onQuarternaryHandler,
            "data-cy": 'quarternary_button',
            children: quarternaryButtonText
          }) : null, onTertiaryHandler ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.Link, {
            size: '2',
            onClick: onTertiaryHandler,
            "data-cy": 'tertiary_button',
            children: tertiaryButtonText
          }) : null]
        }) : null]
      })]
    })
  });
};
var _default = exports.default = TimeRegCreativeModal;
TimeRegCreativeModal.defaultProps = {
  closeModal: function closeModal(close) {
    return close;
  },
  title: 'Create Title',
  creativeButtonText: 'Create'
};